"use client";

import React from "react";
import { useTranslation } from "../../../../i18n/client";
import ProductCard from "./ProductCard";
import NavigationButton from "./NavigationButton";
import productWebapp from "../../../../../public/images/New-landing/product-webapp.png";
import approvalImg from "../../../../../public/images/New-landing/approval-img.png";
import productVideoThumbnail from "../../../../../public/images/New-landing/product1.jpeg";
import product2VideoThumbnail from "../../../../../public/images/New-landing/product-video-thumbnail.png";

interface ProductsProps {
  lng: string;
  activateCheckbox?: (key: string) => void;
  checkedItems?: { [key: string]: boolean };
}

const Products: React.FC<ProductsProps> = ({
  lng,
  activateCheckbox,
  checkedItems,
}) => {
  const { t }: { t: any } = useTranslation(lng, "new-landing");

  const products = [
    {
      title: t("products.platform.title"),
      subtitle: t("products.platform.subtitle"),
      description: t("products.platform.description"),
      buttonText: t("products.platform.button"),
      image: productWebapp,
      layout: "left",
      type: "mobile",
    },
    {
      title: t("products.webapp.title"),
      subtitle: t("products.webapp.subtitle"),
      description: t("products.webapp.description"),
      image: productWebapp,
      layout: "right",
      type: "web",
    },
    {
      title: t("products.approvals.title"),
      subtitle: t("products.approvals.subtitle"),
      description: t("products.approvals.description"),
      buttonText: t("products.approvals.button"),
      image: approvalImg,
      layout: "left",
      type: "mobile",
    },
  ];

  const videoCard = {
    thumbnail: productVideoThumbnail,
  };

  const handleDemoClick = (productTitle: string) => {
    if (activateCheckbox && checkedItems) {
      if (
        productTitle === t("products.platform.title") &&
        !checkedItems["omto-dktb"]
      ) {
        activateCheckbox("omto-dktb");
      } else if (
        productTitle === t("products.approvals.title") &&
        !checkedItems["intelligent-modules"]
      ) {
        activateCheckbox("intelligent-modules");
      }
    }
  };

  return (
    <section id="products" className="w-full bg-omto-light py-[24px]">
      <div className="relative">
        <div className="flex justify-center">
          <NavigationButton
            text={t("products-navigation-up")}
            targetId="about"
            direction="up"
            textClassName="text-omto-dark text-center"
          />
        </div>

        <div className="">
          <ProductCard
            {...products[0]}
            videoCard={{
              thumbnail: videoCard.thumbnail,
            }}
            onButtonClick={() => handleDemoClick(products[0].title)}
          />

          <ProductCard 
            {...products[1]} 
            videoCard={{
              thumbnail: product2VideoThumbnail,
              youtubeUrl: "https://www.youtube.com/watch?v=fgbI8gbMOjQ"
            }}
            className="pb-4 sm:pb-6"
          />

          <ProductCard
            {...products[2]}
            onButtonClick={() => handleDemoClick(products[2].title)}
            className="pt-4 sm:pt-6"
          />
        </div>

        <div className="flex justify-center">
          <NavigationButton
            text={t("products-navigation-down")}
            targetId="contact"
            direction="down"
          />
        </div>
      </div>
    </section>
  );
};

export default Products;
